import type { CsvFilters } from '@/generated/GeneratedApiTypes';
import { useExportCsvMutation } from '@/services/api';

interface UseCsvExportResult {
    exportCsv: (filters: CsvFilters) => void;
    isExporting: boolean;
}

export const useCsvExport = (): UseCsvExportResult => {
    const [exportCsvMutation, { isLoading }] = useExportCsvMutation();

    const exportCsv = (filters: CsvFilters) => {
        exportCsvMutation(filters);
    };

    return { exportCsv, isExporting: isLoading };
};
